const colors = {
    light: '#f8f9fa',
    dark: '#212529',
    white: '#FFFFFF'
}


const Tags = (props) => {
    const tags = props.tags.map(
        (tag) => {
            return <Tag key={'tag-' + tag.id} tag={tag} />
        }
    )
    let wrapperClass = '';
    if(tags.length > 0)
    {
        wrapperClass = 'pb-3'
    }
    return (
        <div className={wrapperClass}>
            {tags}

        </div>
    )
}

const Tag = (props) => {
    const iconStyle = {

    }
    const tagBtnIconStyle = {
        backgroundColor: props.tag.color,
        color: colors[props.tag.theme],
        borderStyle: 'solid none solid solid',
        borderColor: colors.dark,
        cursor: 'default'
    }
    const tagBtnNameStyle = {
        borderStyle: 'solid solid solid none',
        backgroundColor: colors.white,
        borderColor: colors.dark,
        cursor: 'default'
    }

    return (
        <div className="btn-group btn-group-sm tag-btn pr-1 pb-1">
            <span className="btn btn-sm tag-btn-icon" style={tagBtnIconStyle}>
                <Icon />
            </span>
            <span className="btn btn-sm tag-btn-name" style={tagBtnNameStyle}>{props.tag.name}</span>
        </div>
    )
}

const Icon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-tag-fill"
             viewBox="0 0 16 16">
            <path
                d="M2 1a1 1 0 0 0-1 1v4.586a1 1 0 0 0 .293.707l7 7a1 1 0 0 0 1.414 0l4.586-4.586a1 1 0 0 0 0-1.414l-7-7A1 1 0 0 0 6.586 1H2zm4 3.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z"/>
        </svg>
    )
}

export default Tags
